export const SERVER_ERROR_CODES = {
  COMMON_SUCCESS: 0,
  COMMON_SAVE_SUCCESS: 1,
  COMMON_ADD_SUCCESS: 2,
  COMMON_UPDATE_SUCCESS: 3,
  COMMON_DEL_SUCCESS: 4,
  COMMON_ERROR: 1000,
  COMMON_COLUMN_INVALID: 1001,
  COMMON_COLUMN_REQUIRED: 1002,
  COMMON_COLUMN_VALUE_NOT_ALLOWED: 1003,
  COMMON_DATA_ALREADY_EXIST: 1005,
  COMMON_SAVE_FAIL: 1006,
  COMMON_TOKEN_INVALID: 1009,
  COMMON_DATA_NOT_FOUND: 1010,
  COMMON_DATA_MODIFIED: 1011,
  COMMON_DEL_FAIL: 1012,
  COMMON_FAILED_TO_PARSE_JSON_REQUEST: 1013,
  COMMON_DATA_FORMAT_ERROR: 1019,
  COMMON_ACCESS_DENIED: 1020,
  COMMON_READ_DENIED: 1021,
  COMMON_WRITE_DENIED: 1022,
  COMMON_DELETE_DENIED: 1023,
  COMMON_INTERNAL_ERROR: 1024,
  COMMON_DATA_DELETED: 1025,
  COMMON_TOKEN_EXPIRED: 1026,
  COMMON_CONDITION_DATA_INCOMPLETE: 1040,
  COMMON_ENCOUNTER_CARD_QUERY_FAILED: 1041,
  COMMON_PATIENT_CARD_QUERY_FAILED: 1042,
  COMMON_GATEWAY_ACCESS_DENIED: 1043,
  COMMON_USER_STATUS_IS_ALREADY_CHANGED: 1044,
  HOME_QUERY_DAYS_OUT_OF_RANGE: 2001,
  HOME_ALREADY_COMPLETED: 2002,
  HOME_ALREADY_INCOMPLETE: 2003,
  HOME_ENCOUNTER_QUERY_FAILED: 2004,
  CDR_DOWNLOAD_FILE_FAILED: 3001,
  BASIC_PASSWORD_STRENGTH_INVALID: 4001,
  BASIC_SUPER_ADMIN_OPERATION_FORBIDDEN: 4002,
  BASIC_CANNOT_OPERATE_SELF: 4003,
  BASIC_USER_NOT_ACTIVE: 4004,
  BASIC_SUPER_ADMIN_PRACTITIONER_TYPE_FORBIDDEN: 4005,
  BASIC_SUPER_ADMIN_MAIL_FORBIDDEN: 4006,
  BASIC_MAIL_SEND_FAILED: 4007,
  BASIC_USER_NOT_DISABLED: 4010,
  BASIC_USER_MOBILE_DUPLICATED: 4011,
  BASIC_OLD_PASSWORD_INCORRECT: 4012,
  BASIC_PASSWORD_RULE_INVALID: 4013,
  BASIC_PASSWORD_NOT_MATCH: 4014,
  BASIC_ESIGN_FILE_NOT_FOUND: 4015,
  AUTH_ACCOUNT_AND_PASSWORD_NOT_MATCH: 7001,
  AUTH_TOKEN_EXPIRED: 7002,
  AUTH_EXTERNAL_AUTH_INVALID: 7003,
  AUTH_EXTERNAL_AUTH_DISABLED: 7004,
  AUTH_USER_EMAIL_NOT_FOUND: 7005,
  AUTH_USER_NO_TENANT_PERMISSION: 7006,
  AUTH_ACCOUNT_STATUS_NOT_ALLOWED: 7007,
  AUTH_DATE_BEFORE_TODAY: 7008,
  AUTH_EFFECTIVE_DATE_AFTER_EXPIRY_DATE: 7009,
  AUTH_PERMISSION_GROUP_NAME_DUPLICATED: 7010,
  AUTH_PERMISSION_GROUP_DISABLED: 7011,
  AUTH_PERMISSION_NOT_AVAILABLE: 7012,
  AUTH_PERMISSION_GROUP_NOT_FOUND: 7013,
  AUTH_PERMISSION_GROUP_ALREADY_DISABLED: 7014,
  AUTH_PERMISSION_GROUP_HAS_ASSIGNED_USERS: 7015,
  AUTH_PERMISSION_ALREADY_ASSIGNED: 7016,
  AUTH_PERMISSION_GROUP_ALREADY_ACTIVE: 7017,
  AUTH_PERMISSION_GROUP_NOT_AVAILABLE: 7018,
  AUTH_PERMISSION_GROUP_ALREADY_ASSIGNED: 7019,
  AUTH_USER_ALREADY_REMOVED: 7020,
  AUTH_PERMISSION_NOT_EXIST_OR_DISABLED: 7021,
  AUTH_PERMISSION_GROUP_MUST_BE_DISABLED_BEFORE_DELETE: 7022,
  FGT_TEMPLATE_CODE_EXIST: 12001,
  FGT_TEMPLATE_HAS_NEWER_VERSION: 12002,
  FGT_TEMPLATE_VERSION_STATUS_CONFLICT: 12003,
  FGT_TEMPLATE_UPDATE_ONLY_DRAFT: 12004,
  FGT_TEMPLATE_DELETE_ONLY_DRAFT: 12005,
  FGT_TEMPLATE_STATUS_UNKNOWN: 12006,
  FGT_RUNTIME_FORM_LIMIT_EXCEEDED: 12007,
  FGT_RUNTIME_FORM_TEMPLATE_NOT_PUBLISHED: 12008,
  FGT_RUNTIME_FORM_TEMPLATE_DISABLED: 12009,
  FGT_RUNTIME_FORM_WORKFLOW_CONDITION_FAILED: 12010,
  FGT_RUNTIME_FORM_STATUS_UNKNOWN: 12011,
  FGT_RUNTIME_FORM_TODO_STATUS_UNKNOWN: 12012,
  FGT_STATUS_TRANSITION_INVALID: 12013,
  FGT_CONDITION_OPERATOR_NOT_SUPPORTED: 12014,
  FGT_COMPONENT_FOLDER_NAME_DUPLICATE: 12015,
  FGT_COMPONENT_NAME_DUPLICATE: 12016,
  FGT_ENCOUNTER_QUERY_FAILED: 12017,
  FGT_OPTION_ORDER_QUERY_FAILED: 12018,
  FGT_OPTION_NOTIFICATION_USER_QUERY_FAILED: 12019,
  FGT_OPTION_ROUTE_QUERY_FAILED: 12020,
  FGT_OPTION_NOTIFICATION_METHOD_QUERY_FAILED: 12021,
  FGT_OPTION_FREQUENCY_QUERY_FAILED: 12022,
  FGT_OPTION_ALERT_ICON_QUERY_FAILED: 12023,
  FGT_OPTION_ADMIN_METHOD_QUERY_FAILED: 12024,
  FGT_PATIENT_QUERY_FAILED: 12025,
  FGT_DIVISION_QUERY_FAILED: 12026,
  FGT_QR_CODE_EXPIRED: 12027,
  FGT_NOT_FOUND_SYSTEM_CONFIG_TEMPLATE: 12028,
  INIS_STATION_ACCESS_DENIED: 13001,
  INIS_GRPC_PERMISSION_SERVICE_ERROR: 13002,
  INIS_PRIMARY_BED_STATUS_CONFLICT: 13003,
  INIS_ENCOUNTER_QUERY_FAILED: 13004,
  INIS_PATIENT_QUERY_FAILED: 13005,
  INIS_ADMINISTRATION_CHECK_SAME_USER: 13006,
  INIS_ADMINISTRATION_CHECK_NOT_ALLOWED: 13007,
  INIS_ADMINISTRATION_CHECK_CREDENTIAL_INVALID: 13008,
  INIS_ADMINISTRATION_CHECK_SERVICE_ERROR: 13009,
  INIS_MEDICATION_ORDER_CANCELLED: 13010,
  INIS_MEDICATION_NOT_DUE: 13011,
  INIS_MEDICATION_OUTSIDE_WINDOW: 13012,
  INIS_MEDICATION_PRN_REASON_REQUIRED: 13013,
  INIS_MEDICATION_INJECTION_ADMIN_ID_REQUIRED: 13014,
  INIS_MEDICATION_DUAL_CHECK_REQUIRED: 13015,
  INIS_TENANT_CODE_TYPE_QUERY_FAILED: 13016,
  INIS_MEDICATION_NOT_COMPLETED: 13017,
  INIS_MEDICATION_CANCEL_CONFLICT: 13018,
  SDRS_PATIENT_ALREADY_EXISTS: 18001,
  SDRS_PATIENT_QUERY_FAILED: 18002,
  SDRS_PREGNANCY_INFO_QUERY_FAILED: 18003,
  SDRS_ENCOUNTER_QUERY_FAILED: 18004,
  SDRS_PRACTITIONER_QUERY_FAILED: 18005,
  SDRS_BED_TRANSFER_QUERY_FAILED: 18006,
  SDRS_BED_TRANSFER_ADD_FAILED: 18007,
  SDRS_BED_TRANSFER_UPDATE_FAILED: 18008,
  SDRS_CLINICAL_SUMMARY_QUERY_FAILED: 18009,
  SDRS_EXAM_ORDER_QUERY_FAILED: 18010,
  SDRS_ORDER_DRAIN_QUERY_FAILED: 18011,
  SDRS_OBSERVATION_VITAL_QUERY_FAILED: 18012,
  SDRS_TRANSFUSION_QUERY_FAILED: 18013,
  SDRS_DRAIN_TUBE_QUERY_FAILED: 18014,
  SDRS_LAB_REPORT_QUERY_FAILED: 18015,
  SDRS_TENANT_CODE_TYPE_QUERY_FAILED: 18016,
} as const;

export type ServerErrorCode =
  (typeof SERVER_ERROR_CODES)[keyof typeof SERVER_ERROR_CODES];
